import { observer } from 'mobx-react-lite';
import React from 'react';
import { ViewTypeState } from '../../state/ViewTypeState';
import { LayoutSwitchButton } from '../LayoutSwitchButton';

export interface TableGridSwitchButtonProps {
  state: ViewTypeState;
}

function _TableGridSwitchButton({ state }: TableGridSwitchButtonProps) {
  return <LayoutSwitchButton state={state} options={['table', 'grid']} />;
}

export const TableGridSwitchButton = observer(_TableGridSwitchButton);
